module.exports = __webpack_public_path__ + "static/me-04a97987d1bd788c58d496a1657eb701.jpg";